<template>
	<div class="conversation-info-navbar navbar card">
		<div class="navbar-section solo-navbar-section">
			<button
				@click="closeConversationInfo()"
				class="closebtn btn action link lg"
			>
				<icon>close</icon>
			</button>
		</div>
	</div>
</template>

<script>
import Icon from './Icon';

export default {
	name: 'ConversationInfoNavbar',
	components: {
		Icon
	},
	data() {
		return {};
	},
	methods: {
		closeConversationInfo() {
			this.$emit('update:conversationInfoOpen', false);
		}
	}
};
</script>
